<template>
<div class="chapter">
<div class="inner_page">
<p class="CTA"><span epub:type="pagebreak" id="pagev" title="v"></span><a href="#/Text/Contents#ded"><span class="blue">Dedication</span></a></p>
<p class="DED"><span epub:type="pagebreak" id="pagevi" title="vi"></span><span class="ital">For Scott—my husband—</span>my<span class="ital"> prince</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?20687779